<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-04-07 12:53:13
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-06-13 08:42:59
 * @FilePath: \website\src\components\element\options\cpt-iframe-option.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <t-form-item label="获取父级参数">
      <div style="display: flex;flex-direction: column;">
        <t-radio-group style="margin-bottom:10px;" v-model="attribute.getFatherUrlParams" size="small">
          <t-radio-button :value="1">是</t-radio-button>
          <t-radio-button :value="0">否</t-radio-button>
        </t-radio-group>
      </div>
    </t-form-item>
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
export default {
  name: "cpt-input-option",
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  components: { CptData },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

<style scoped></style>